import { render, staticRenderFns } from "./quality-assurance-ws-feedback.vue?vue&type=template&id=2b5b6a3e&scoped=true&"
import script from "./quality-assurance-ws-feedback.vue?vue&type=script&lang=js&"
export * from "./quality-assurance-ws-feedback.vue?vue&type=script&lang=js&"
import style0 from "./quality-assurance-ws-feedback.vue?vue&type=style&index=0&id=2b5b6a3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b6a3e",
  null
  
)

export default component.exports